import { useSelector } from "react-redux";
import { RootState } from "../../../store/combineReducer";

type TenantIndicatorProps = {
  className?: string;
};

/** Badge con el nombre del tenant activo (franquicia o Lavoris). */
export default function TenantIndicator({
  className = "tenant-indicator",
}: TenantIndicatorProps) {
  const { branding, slug } = useSelector((state: RootState) => state.franchise);

  const label =
    branding?.fantasyName ||
    branding?.name ||
    (slug ? slug : "Lavoris");

  return (
    <span className={className} title={`Tenant: ${label}`}>
      {label}
    </span>
  );
}
